const globalAfterSale = {
    path: "globalManage",
    name: "globalManage",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'system',
        icon: 'HSIconfont hs-icon-sys',
        showRealm: ['GLOBAL']
    },
    children: [
        {
            path: 'globalConfig',
            name: 'globalConfig',
            component: () => import('@/views/globalConfig'),
            meta: { code: 'system:config' }
        },
        {
            path: 'globalApiAuth',
            name: 'globalApiAuth',
            component: () => import('@/views/globalApiAuthentication'),
            meta: { code: 'system:apiAuth' }
        },
    ]
};
export default globalAfterSale;
